var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        [
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-back" },
              on: { click: _vm.returnFun }
            },
            [_vm._v("返 回")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary" },
              on: { click: _vm.addFun }
            },
            [_vm._v("添加巡点")]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.title,
                width: "600px",
                visible: _vm.addPos,
                "before-close": _vm.closeDiglog,
                center: ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.addPos = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "addPos",
                  attrs: {
                    model: _vm.addData,
                    rules: _vm.rules,
                    "label-width": "160px",
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "巡点名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "280px" },
                        attrs: { type: "text" },
                        model: {
                          value: _vm.addData.name,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "name", $$v)
                          },
                          expression: "addData.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "巡点类型", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-item",
                          staticStyle: { width: "200px" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择地点类型"
                          },
                          model: {
                            value: _vm.addData.type,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "type", $$v)
                            },
                            expression: "addData.type"
                          }
                        },
                        _vm._l(_vm.typeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.value, value: item.key }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "710px" } },
            _vm._l(_vm.mapPosData, function(pos, index) {
              return _c("div", { key: index, staticClass: "posDiv" }, [
                _c("img", {
                  key: index,
                  staticStyle: {
                    position: "relative",
                    left: "0px",
                    top: "0px"
                  },
                  attrs: {
                    src:
                      "https://cdn-tech.cozzia.com.cn/dev/robot/news/20200320140958_mnrr.svg",
                    width: "25px"
                  },
                  on: {
                    mousedown: function($event) {
                      return _vm.move($event, pos, index)
                    },
                    load: function($event) {
                      return _vm.imageLoad($event, pos, index)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.updateMenu(pos)
                      }
                    }
                  },
                  [_vm._v(_vm._s(pos.name))]
                ),
                _vm._v(" "),
                _c(
                  "i",
                  {
                    on: {
                      click: function($event) {
                        return _vm.delMenu(pos, index)
                      }
                    }
                  },
                  [_vm._v("x")]
                )
              ])
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-main", [
        _c(
          "div",
          { staticStyle: { position: "relative", top: "0px", left: "0px" } },
          [_c("img", { attrs: { src: _vm.mapSrc, height: "745px" } })]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }